import React from 'react';
import { ScheduleNowSession } from '../../types/types';
import { canPlayInApp, OnAirCard } from '../../utils/live';
import { color, font, radius, space, tone, weight } from '../../theme';
import Icon from '../Icon';
import { externalWatchUrl, hhmm, WatchLiveButton } from './PlayButtons';

/* The live banner in a committee page's header (decision 1E): the committee is on air, since
   when, the session's subject, and "צפייה בשידור", which opens the in-app player (or links out
   to the session's page when the stream can't play here). On a break the banner is grey and
   says so. Without the live feed (the time rule) it reads as before: "הוועדה בשידור עכשיו". */

const CLAMP_2: React.CSSProperties = { display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' };

const CommitteeLiveBanner = ({ card }: { card: OnAirCard<ScheduleNowSession> }) => {
  const since = hhmm(card.since);
  const canWatch = canPlayInApp(card.streamUrl) || externalWatchUrl(card) !== null;
  return (
    <div
      style={{
        display: 'flex', flexDirection: 'column', gap: space.sm, textAlign: 'right',
        background: card.paused ? color.surfaceMuted : tone.danger.bg, borderRadius: radius.md, padding: `${space.sm + 2}px ${space.md}px`,
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: space.sm, fontSize: font.small, fontWeight: weight.bold, color: card.paused ? color.textSecondary : color.oppositionText }}>
        {card.paused
          ? <Icon name="pause" size={14} strokeWidth={2.2} />
          : <span style={{ width: 8, height: 8, borderRadius: '50%', background: color.live, flexShrink: 0 }} />}
        {card.paused ? 'השידור בהפסקה' : 'הוועדה בשידור עכשיו'}
        {since && ` · ${card.paused ? 'מתקיים ' : ''}מאז ${since}`}
      </span>
      {card.subject && (
        <span style={{ fontSize: font.small, color: card.paused ? color.text : tone.danger.fg, lineHeight: 1.45, ...CLAMP_2 }}>{card.subject}</span>
      )}
      {canWatch && <span><WatchLiveButton card={card} label="צפייה בשידור" /></span>}
    </div>
  );
};

export default CommitteeLiveBanner;
